// QESG ASSESSMENT 중 Campaigns 관련 Store
// Industry_id 있는 campaigns만 취급하므로 별도 store로 관리함
import i18n from '@/i18n'
import axios from '@core_utils/api/_axios.js'
import * as ih from '@core_utils/util'
import * as th from 'tree-helper'
import commonLogout from '@core_utils/common-logout'

const industry_campaigns = {
    namespaced: true,
    state: {
        campaigns: [],
        is_campaigns_loaded: false,
        industries: [],
        nice_services_status: [],
        benchmark: [],
        history_scores: {},
        is_history_score_loaded: false,
        is_nice_services_status_loaded: false,
        category1_filled_rate: [],
        total_filled_rate: [],
        is_filled_rate_loaded: false,
        category1_progress_rate: [],
        total_progress_rate: [],
        is_progress_rate_loaded: false,
        custom_project_code: '',
        custom_template: {},
        custom_template_loaded: false
    },
    getters: {},
    mutations: {
        update_campaigns_industries_list(state, new_campaigns_list) {
            state.campaigns = new_campaigns_list
            state.is_campaigns_loaded = true
        },
        update_campaign_status(state, {campaign_id, status}) {
            let idx = state.campaigns.findIndex(item => item.campaign_id == campaign_id)
            if (idx > -1) {
                let new_campaign = {...state.campaigns[idx]}
                new_campaign.campaign_state = status
                state.campaigns.splice(idx, 1, new_campaign)
            }
        },
        delete_campaign(state, campaign_id) {
            let idx = state.campaigns.findIndex(item => item.campaign_id == campaign_id)
            if (idx > -1) {
                state.campaigns.splice(idx, 1)
            }
        },
        update_is_campaigns_loaded(state, mode) {
            state.is_campaigns_loaded = mode
        },
        update_industries(state, new_industry_list) {
            state.industries = new_industry_list
        },
        update_nice_service_status(state, new_list) {
            state.nice_services_status = new_list
        },
        update_nice_service_status_loaded(state, flag) {
            state.is_nice_services_status_loaded = flag
        },
        update_history_scores(state, new_scores) {
            let temp_scores = {}
            // console.log(new_scores);
            new_scores.forEach(item => {
                temp_scores[item.company_id] = {
                    'company_id': item.company_id,
                    'total_score': item.score_obj.scoring.total_scoring_pd[0]["score"],
                    'category1_scores': item.score_obj.scoring.category1_scoring_pd
                }
            })
            // console.log(temp_scores);

            state.history_scores = temp_scores
            state.is_history_score_loaded = true
        },
        update_is_history_score_loaded(state, flag) {
            state.is_history_score_loaded = flag
        },
        update_filled_rates(state, new_list) {
            let temp_cat1_filled = new_list.category1_filled_rate
            let temp_total_filled = new_list.total_filled_rate
            state.category1_filled_rate = temp_cat1_filled
            state.total_filled_rate = temp_total_filled
        },
        update_filled_rate_loaded(state, flag) {
            state.is_filled_rate_loaded = flag
        },
        update_progress_rates(state, new_list) {
            // console.log(new_list);
            let temp_cat1_progress = new_list.category1_progress_rate
            let temp_total_progress = new_list.total_progress_rate
            state.category1_progress_rate = temp_cat1_progress
            state.total_progress_rate = temp_total_progress
        },
        update_progress_rate_loaded(state, flag) {
            state.is_progress_rate_loaded = flag
        },
        update_custom_project_code(state, new_code) {
            state.custom_project_code = new_code
        },
        update_custom_template(state, new_obj) {
            state.custom_template = new_obj
        },
        update_custom_template_loaded(state, flag) {
            state.custom_template_loaded = flag
        },
        make_template_tree(state, question_array) {
            th.breadthFirstSearch(state.custom_template.template_contents, node => {
                let idx = question_array.findIndex(item => {
                    return item.question_code == node.question_code
                })
                if (idx > -1) {
                    node.question_name = question_array[idx].question_name
                    node.question_name_e = question_array[idx].question_name_e
                    node.question_infobox = question_array[idx].question_infobox
                    node.question_infobox_e = question_array[idx].question_infobox_e
                    node.question_contents = question_array[idx].question_contents
                    node.is_completed = question_array[idx].is_completed
                }
            })
            // console.log(state.custom_template.template_contents);
            state.custom_template_loaded = true
        },

    },
    actions: {
        async readCampaignsIndustries({commit}, user_id) {
            try {
                commit('update_is_campaigns_loaded', false)
                const response = await axios.get('/read_campaigns_industries', {
                    params: {user_id}
                })
                commit('update_campaigns_industries_list', response.data)
            } catch (error) {
                console.log(error)
                return error
            } finally {
                commit('update_is_campaigns_loaded', true)
            }
        },
        async readSingleCampaignIndustries({commit}, {user_id, campaign_id}) {
            try {
                commit('update_is_campaigns_loaded', false)
                const response = await axios.get('/read_campaigns_industries', {
                    params: {user_id, campaign_id}
                })
                commit('update_campaigns_industries_list', response.data)
            } catch (error) {
                console.log(error)
                return error
            } finally {
                commit('update_is_campaigns_loaded', true)
            }
        },
        async readSingleCampaignTargetCompanies({commit}, campaign_id) {
            try {
                const response = await axios.get('/read_single_campaign', {params: {campaign_id: campaign_id}})
                return response.data
            } catch (error) {
                console.log(error)
                return error
            }
        },
        async changeStatus({commit, state}, {campaign, status}) {
            try {
                let idx = state.campaigns.findIndex(item => item.campaign_id === campaign.campaign_id)
                if (idx > -1) {
                    const formData = new FormData()
                    formData.append('campaign_id', campaign.campaign_id)
                    formData.append('status', status)

                    await axios.post('/change_campaign_status', formData)
                    commit('update_campaign_status', {campaign_id: campaign.campaign_id, status})
                }
            } catch (error) {
                console.log(error)
            }
        },
        deleteCampaign({commit, state, rootState}, campaign) {
            const idx = state.campaigns.findIndex(function (item) {
                return item.campaign_id == campaign.campaign_id
            })

            if (idx > -1) {
                const path = rootState.backend_host + '/delete_campaign'
                const formData = new FormData()
                formData.append('campaign_id', campaign.campaign_id)

                return axios.post(path, formData)
                    .then(response => {
                        const result = response.data.response_message
                        commit('delete_campaign', campaign.campaign_id)
                        // EventBus.$emit('toast-success', '알림', `${campaign.campaign_name}을 성공적으로 삭제하였습니다.`)
                    })
                    .catch(error => {
                        if (error.response) {
                            if (error.response.status == '401') {
                                alert(i18n.t(`다중 로그인 등 권한 오류가 발생했습니다. 다시 로그인해 주십시오.`))
                                this.dispatch('logout').then(() => {
                                    this.$router.push({name: 'Login'})
                                })
                            }
                        } else {
                            console.log(error)
                        }
                    })
            }
        },
        async readAllIndustries({commit}, user_id) {
            try {
                const response = await axios.get('/read_all_industries', {
                    params: {user_id}
                })

                commit('update_industries', response.data)
            } catch (error) {
                console.log(error)
            }
        },
        async readNiceServiceStatus({commit}, {campaign_id, company_id}) {
            try {
                const response = await axios.get('/read_nice_service_status', {
                    params: {campaign_id: campaign_id, company_id: company_id}
                })
                commit('update_nice_service_status', response.data)
                commit('update_nice_service_status_loaded', true)
            } catch (error) {
                console.log(error)
            }
        },
        async readHistoryScores({commit}, {campaign_id, project_code}) {
            try {
                // 완료된 기업의 점수만 읽어오기
                const response = await axios.get('/read_total_scores_history', {
                    params: {
                        campaign_id: campaign_id,
                        project_code: project_code
                    }
                })
                commit('update_history_scores', response.data)
                commit('update_is_history_score_loaded', true)
            } catch (error) {
                console.log(error)
            }
        },
        async distributeCompanyReport(ctx, {campaign_id, project_code, company_id, nice_permit_required, report, en}) {
            const formData = new FormData()
            formData.append('campaign_id', campaign_id)
            formData.append('company_id', company_id)
            formData.append('project_code', project_code)
            formData.append('nice_permit_required', nice_permit_required)
            formData.append('report', report)
            formData.append('en', en)

            // Debug Code: NICE에 신청정보 없어도 강제로 업로드함
            // formData.append('nice_permit_required', false)

            const response = await axios.post('/report/submit',
                formData,
                {
                    headers: {'Content-Type': 'multipart/form-data'},
                    params: {campaign_id, company_id, project_code, nice_permit_required, en}
                }
            )
            return response
        },
        async readFilledRate({commit}, {campaign_id, company_id}) {
            try {
                const response = await axios.get('/read_qe_filled_rate', {
                    params: {campaign_id: campaign_id, company_id: company_id}
                })
                commit('update_filled_rates', response.data)
                commit('update_filled_rate_loaded', true)
            } catch (error) {
                console.log(error)
            }
        },
        async readProgressRate({commit}, {campaign_id, company_id}) {
            try {
                const response = await axios.get('/read_qe_progress', {
                    params: {campaign_id, company_id}
                })

                commit('update_progress_rates', response.data)
                commit('update_progress_rate_loaded', true)
            } catch (error) {
                console.log(error)
            }
        },
        async readCustomTemplate({commit, dispatch}, {project_code, company_id}) {
            try {
                let new_template_tree = {}
                const response = await axios.get('/read_custom_template', {
                    params: {project_code}
                })

                if (response.data.code === 'success') {
                    new_template_tree.template_name = response.data.template_name
                    new_template_tree.template_code = response.data.template_code
                    new_template_tree.template_scoring = response.data.template_scoring
                    new_template_tree.template_type = response.data.template_type
                    new_template_tree.template_contents = ih.JSONParse(response.data['template_contents'])

                    await dispatch('makeTemplateTree', {
                        template_code: new_template_tree.template_code,
                        company_id: company_id
                    })

                    commit('update_custom_template', new_template_tree)
                    commit('update_custom_template_loaded', true)
                } else {
                    commit('update_custom_template', new_template_tree)
                    commit('update_custom_template_loaded', true)
                }
            } catch (error) {
                if (error.response) {
                    if (error.response.status === 401) {
                        await commonLogout()
                    }
                }
            }
        },
        async makeTemplateTree({commit}, {template_code, company_id}) {
            try {
                const response = await axios.get('/make_custom_template_tree', {
                    params: {template_code, company_id}
                })
                commit('make_template_tree', response.data)
            } catch (error) {
                console.log(error)
            }
        }
    }
}

export default industry_campaigns
